// libraries
import React from 'react'

export const AngleUp = () => {
    return (
        <svg width='18' height='11' viewBox='0 0 18 11' xmlns='http://www.w3.org/2000/svg'><path d='M9.00015 0.0859375L17.9144 9.00015L16.5002 10.4144L9.00015 2.91436L1.50015 10.4144L0.0859375 9.00015L9.00015 0.0859375Z' fill='currentColor'/></svg>
    )
}

export const AngleDown = () => {
    return (
        <svg width='18' height='11' viewBox='0 0 18 11' xmlns='http://www.w3.org/2000/svg'><path d='M1.50015 0.585938L9.00015 8.08594L16.5002 0.585938L17.9144 2.00015L9.00015 10.9144L0.0859375 2.00015L1.50015 0.585938Z' fill='currentColor'/></svg>
    )
}

export const AngleLeft = () => {
    return (
        <svg width="14" height="24" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 23.3C11.7 23.3 11.4 23.2 11.1 22.9L1.1 12.9C0.599998 12.4 0.599998 11.6 1.1 11.1L11.1 1.09998C11.6 0.599976 12.4 0.599976 12.9 1.09998C13.4 1.59998 13.4 2.39998 12.9 2.89998L3.8 12L12.9 21.1C13.4 21.6 13.4 22.4 12.9 22.9C12.7 23.2 12.3 23.3 12 23.3Z"/></svg>
    )
}

export const AngleRight = () => {
    return (
        <svg width="14" height="24" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 23.3C1.7 23.3 1.4 23.2 1.1 22.9C0.6 22.4 0.6 21.6 1.1 21.1L10.2 12L1.1 2.89998C0.6 2.39998 0.6 1.59998 1.1 1.09998C1.6 0.599976 2.4 0.599976 2.9 1.09998L12.9 11.1C13.4 11.6 13.4 12.4 12.9 12.9L2.9 22.9C2.6 23.2 2.3 23.3 2 23.3Z"/></svg>
    )
}